import { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

interface FileContextType {
  filesContext: File[];
  setFilesContext: (newFiles: File[]) => void;
  clearFiles: () => void;
}
const FileContext = createContext<FileContextType | undefined>(undefined);

export const useFileContext = () => {
  const context = useContext(FileContext);
  if (context === undefined) {
    throw new Error('useFileContext deve essere usato all\'interno di FileProvider');
  }
  return context;
};


export const FileProvider = ({ children } : { children: ReactNode }) => {
  const [filesContext, setFileState] = useState<File[]>([]);

  // impostiamo i file
  const setFilesContext = useCallback((newFiles: File[]) => {
    // verifichiamo che l'input sia un array di File
    if (Array.isArray(newFiles) && newFiles.every(file => file instanceof File)) {
        setFileState(newFiles);
    } else {
        throw new Error("[FileProvider] Tentativo di impostare un valore non valido come files.");
    }
  }, []);

   // funzione per cancellare i file
  const clearFiles = useCallback(() => {
    setFileState([]);
  }, []);

  const contextValue = useMemo(() => ({
    filesContext,
    setFilesContext,
    clearFiles,
  }), [filesContext, setFilesContext, clearFiles]);

  return (
    <FileContext.Provider value={contextValue}>
      {children}
    </FileContext.Provider>
  );
};